"use client";
import Image from "next/image";
import { IconsData } from "@/services/directory-detail/types";
import { useCallback } from "react";

type ContactIconsProps = IconsData;

export const Icons = ({ emailAddress, vCard }: ContactIconsProps) => {
  const onEmailClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      window.open(`mailto:${emailAddress}`, "_blank");
    },
    [emailAddress]
  );
  const onContactVCardClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      window.open(vCard, "_blank");
    },
    [vCard]
  );

  if (!emailAddress && !vCard) return null;

  return (
    <div className="flex gap-1" automation-id="contact-card-icons">
      {emailAddress && (
        <span onClick={onEmailClick} className="cursor-pointer">
          <Image
            src={"/email-icon.svg"}
            alt="email-icon"
            width={24}
            height={24}
          />
        </span>
      )}
      {vCard && (
        <span
          className="mt-[0.5px] cursor-pointer"
          onClick={onContactVCardClick}
        >
          <Image
            src={"/v-card-icon.svg"}
            alt="vCard-icon"
            width={22}
            height={22}
          />
        </span>
      )}
    </div>
  );
};
